module.exports = __webpack_public_path__ + "img/Group 1201.1b4071f7.svg";